import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { SnackBarService } from 'src/app/services/snack-bar.service';
import { WhiteSpaceValidator } from 'src/app/validators/white-space.validator';
import { AddonOutputDto, AddonService, AddonUpdateDto, StoreResponseDto } from 'src/generated_client';

@Component({
  selector: 'app-edit-extra',
  templateUrl: './edit-extra.component.html',
  styleUrls: ['./edit-extra.component.css']
})
export class EditExtraComponent implements OnInit {

  editExtraForm: FormGroup = this.fb.group({
    name: ['', Validators.compose([Validators.required,Validators.pattern('[A-Z][a-z ]*'), WhiteSpaceValidator.cannotContainSpace])],
    price: ['', Validators.compose([Validators.required, Validators.min(1)])]
  })

  constructor(
    private fb: FormBuilder,
    private addonService: AddonService,
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private router: Router,
    private snackBar: SnackBarService
  ) { }

  addonOutput: AddonOutputDto = {} as AddonOutputDto;
  addonUpdate: AddonUpdateDto = {} as AddonUpdateDto;
  storeResponse: StoreResponseDto = {} as StoreResponseDto;
  id: any;


  ngOnInit(): void {
    this.storeResponse = this.authService.currentUserStore();
    this.id = this.activatedRoute.snapshot.paramMap.get("id");
    this.addonService.apiAddonGetOneGet(this.id).subscribe(x => {
      this.editExtraForm.controls['name'].setValue(x.dsName),
        this.editExtraForm.controls['price'].setValue(x.qtPrice)
    })
  }

  saveChanges(form: any) {
    this.addonUpdate = {
      cdAddon: Number(this.id), dsName: form.name, qtPrice: form.price,
      cdStore: Number(this.storeResponse.cdStore)
    };
    this.addonService.apiAddonPutPut(this.addonUpdate).subscribe(response => {
      this.router.navigate(['additionals'])
      this.snackBar.openSnackBar('Los cambios se guardaron correctamente','Aceptar')
    }, (err) => {
      this.snackBar.openSnackBar(err.error.error, 'Aceptar')

    })
  }

}
